
const isSessionStorageSupported = () => {
    if (typeof (Storage) !== "undefined") {
        try {
            sessionStorage.setItem("saleBidAgreementTest", "saleBidAgreementTest");
            sessionStorage.removeItem("saleBidAgreementTest");
            return true;
        } catch (e) {
            return false;
        }
    }
    return false;
}

let _bBrowserSupportsSessionStorage = isSessionStorageSupported();

let _sAcceptedBidAgreementsCacheKey = "AcceptedBidAgreementsCache";
let _sBidAgreementCacheKey = "BidAgreementCache";
let _sBidAgreementLastResetCacheKey = "BidAgreementCacheLastReset";
let _iBidAgreementCacheResetIntervalMilliseconds = 5 * 60 * 1000;       


/* BEGIN Bid Agreement Acceptance Logic */

const getBAAcceptanceTrackingModelFromSessionStorage = () =>  {
    let stringFromSession = sessionStorage.getItem(_sAcceptedBidAgreementsCacheKey);
    if (stringFromSession != null) {
        let parsedModel = JSON.parse(stringFromSession);
        return {
            ...parsedModel,
            BidAgreementsMap: new Map(parsedModel.BidAgreementsMap)
        };
    }
    return null;

}

const isBAAcceptanceTrackingModelForCurrentUser = (currentUserID, bidAgreementAcceptanceTrackingModel) => {
    return currentUserID == bidAgreementAcceptanceTrackingModel.UserID;
}

const saveBAAcceptanceTrackingModelToSessionStorage = (bidAgreementAcceptanceTrackingModel) => {
    let modelToSave = {
        ...bidAgreementAcceptanceTrackingModel,
        BidAgreementsMap: Array.from(bidAgreementAcceptanceTrackingModel.BidAgreementsMap.entries())
    };

    sessionStorage.setItem(_sAcceptedBidAgreementsCacheKey, JSON.stringify(modelToSave));
}


/* Exported Functions */


const addUpdateBAAcceptanceToSessionStorage = (currentUserID, saleID, acceptedBidAgreement) =>  {
    let createNewModel = false;
    let bidAgreementAcceptanceTrackingModel = getBAAcceptanceTrackingModelFromSessionStorage();

    if (bidAgreementAcceptanceTrackingModel == null) {
        createNewModel = true;
    } else {

        if (isBAAcceptanceTrackingModelForCurrentUser(currentUserID, bidAgreementAcceptanceTrackingModel)) {
            bidAgreementAcceptanceTrackingModel.BidAgreementsMap.set(saleID, acceptedBidAgreement);
        } else {
            //Create new model and add to session storage
            createNewModel = true;
        }
    }

    if (createNewModel) {
        //Create new model and add to session storage        
        bidAgreementAcceptanceTrackingModel = {};

        bidAgreementAcceptanceTrackingModel.UserID = currentUserID;

        let bidAgreementMap = new Map();
        bidAgreementMap.set(saleID, acceptedBidAgreement);
        bidAgreementAcceptanceTrackingModel.BidAgreementsMap = bidAgreementMap;
    }

    //Save model to session storage
    saveBAAcceptanceTrackingModelToSessionStorage(bidAgreementAcceptanceTrackingModel);
}

const clearSessionStorageIfApplicable = () => {
    let urlParams = new URLSearchParams(window.location.search);

    for (const [key, val] of urlParams) {
        if (key.toLowerCase() === 'clearsessionstorage') {
            if (val == 1) {
                sessionStorage.clear();
            }
        }
    }
}


const doesBrowserSessionShowUserAlreadyAcceptedBidAgreement = (currentUserID, saleID) => {
    let bidAgreementAcceptanceTrackingModel = getBAAcceptanceTrackingModelFromSessionStorage();

    if (bidAgreementAcceptanceTrackingModel != null) {
        if (isBAAcceptanceTrackingModelForCurrentUser(currentUserID, bidAgreementAcceptanceTrackingModel)) {
            if (bidAgreementAcceptanceTrackingModel.BidAgreementsMap.has(saleID)) {
                return bidAgreementAcceptanceTrackingModel.BidAgreementsMap.get(saleID);
            }
        }
    }
    return false;
};

/* END Bid Agreement Acceptance Logic */



/* BEGIN Bid Agreement Text Logic */


const getMapFromSessionStorage = (key) => {
    // 1. Retrieve the string
    let retrievedString = sessionStorage.getItem(key);

    if (retrievedString && retrievedString.length != 0) {

        // 2. Convert the JSON string back to an Array
        let retrievedArray = JSON.parse(retrievedString);

        // 3. Create a new Map from the array
        let retrievedMap = new Map(retrievedArray);

        return retrievedMap;
    }
    return null;
}

const saveMapToSessionStorage = (key, mapToSave) => {
    // 1. Convert Map to Array of arrays (entries)
    const mapAsArray = Array.from(mapToSave.entries());

    // 2. Convert Array to a JSON string
    const mapAsString = JSON.stringify(mapAsArray);

    // 3. Store the string in sessionStorage
    sessionStorage.setItem(key, mapAsString);
}

const saveLastResetBidAgreementTextDateFromSessionStorage = () => {
    sessionStorage.setItem(_sBidAgreementLastResetCacheKey, JSON.stringify(new Date()));
}

const getLastResetBidAgreementTextDateFromSessionStorage = () => {  


    let stringFromSession = sessionStorage.getItem(_sBidAgreementLastResetCacheKey);
    if (stringFromSession != null) {
        return JSON.parse(stringFromSession);
    }
    return null;
}

/*
    Handles resetting the bid agreement text cache if the last reset was more than five minutes ago.
*/
const resetBidAgreementTextDateIfApplicable = () => {
    let lastReset = getLastResetBidAgreementTextDateFromSessionStorage();
    let lastResetTime = Date.parse(lastReset);

    if (lastReset == null || !Number.isFinite(lastResetTime) || Date.now() - lastResetTime >= _iBidAgreementCacheResetIntervalMilliseconds) {
        saveLastResetBidAgreementTextDateFromSessionStorage();

        sessionStorage.removeItem(_sBidAgreementCacheKey);  //Remove the bid agreement text cache
    }
}

const getBidAgreementTextForSaleFromSessionStorage = (saleID) => {

    if (_bBrowserSupportsSessionStorage) {
        resetBidAgreementTextDateIfApplicable();

        let mapBidAgreements = getMapFromSessionStorage(_sBidAgreementCacheKey);

        if (mapBidAgreements && mapBidAgreements.has(saleID)) {
            return mapBidAgreements.get(saleID);
        }
    }
    return null;
}


const addBidAgreementTextToSessionStorage = (saleID, bidAgreementText) => {
    resetBidAgreementTextDateIfApplicable();

    let mapBidAgreements = getMapFromSessionStorage(_sBidAgreementCacheKey);

    if (mapBidAgreements) {
        mapBidAgreements.set(saleID, bidAgreementText);
    } else {
        mapBidAgreements = new Map();

        mapBidAgreements.set(saleID, bidAgreementText);
    }

    saveMapToSessionStorage(_sBidAgreementCacheKey, mapBidAgreements);
}


/* END Bid Agreement Text Logic */





export {
    addBidAgreementTextToSessionStorage,
    addUpdateBAAcceptanceToSessionStorage,
    clearSessionStorageIfApplicable,
    doesBrowserSessionShowUserAlreadyAcceptedBidAgreement,
    getBidAgreementTextForSaleFromSessionStorage,
    isSessionStorageSupported
};